import "./../vendor/cookieconsent.min.js";

window['CookieConsent'].init({
    // More link URL on bar
    modalMainTextMoreLink: null,
    // How lond to wait until bar comes up
    barTimeout: 1000,
    // Look and feel
    theme: {
        barColor: '#000000',
        barTextColor: '#FFF',
        barMainButtonColor: '#FFF',
        barMainButtonTextColor: '#000000',
        modalMainButtonColor: '#4285F4',
        modalMainButtonTextColor: '#FFF',
    },
    language: {
        // Current language
        current: 'en',
        locale: {
            en: {
                barMainText: 'This website uses cookies to ensure you get the best experience.',
                barLinkSetting: 'Cookie Settings',
                barBtnAcceptAll: 'Accept all cookies',
                modalMainTitle: 'Cookie settings',
                modalMainText: 'Here is an overview of the cookies we use on this site. Please select categories that you are OK with. ',
                modalBtnSave: 'Save current settings',
                modalBtnAcceptAll: 'Accept all cookies and close',
                modalAffectedSolutions: 'Affected solutions:',
                learnMore: 'Learn More',
                on: 'On',
                off: 'Off',
            }
        }
    },
    // List all the categories you want to display
    categories: {
        // Unique name
        // This probably will be the default category
        necessary: {
            // The cookies here are necessary and category cant be turned off.
            // Wanted config value  will be ignored.
            needed: true,
            // The cookies in this category will be let trough.
            // This probably should be false if not necessary category
            wanted: true,
            // If the checkbox is on or off at first run.
            checked: true,
            // Language settings for categories
            language: {
                locale: {
                    en: {
                        name: 'Necessary',
                        description: 'These cookies are necessary to make this site run properly and securely. For example, with this kind of cookies, we register your cookie preferences so that you won\'t be seeing this pop - up next time you visit our page and we can keep track which categories you have opted-in.To keep this site secure.'
                    }
                }
            }
        },
        analytics: {
            needed: false,
            wanted: true,
            checked: true,
            language: {
                locale: {
                    en: {
                        name: 'Analytics',
                        description: 'These cookies collect information to help us understand how our website is being used. They allow us to count unique visits and see from where visitors came from. With this information, we can measure and improve the content of our site. We can also see how users navigate between pages and what actions they take.'
                    }
                }
            }
        }
    },
    // List actual services here
    services: {
        // Unique name
        analytics: {
            // Existing category Unique name
            category: 'analytics',
            // Type of blocking to apply here.
            // This depends on the type of script we are trying to block
            // Can be: dynamic-script, script-tag, wrapped, localcookie
            type: 'dynamic-script',
            // Only needed if "type: dynamic-script"
            // The filter will look for this keyword in inserted scipt tags
            // and block if match found
            search: 'analytics',
            // List of known cookie names or Regular expressions matching
            // cookie names placed by this service.
            // These willbe removed from current domain and .domain.
            cookies: [
                {
                    // Known cookie name.
                    name: '_gid',
                    // Expected cookie domain.
                    domain: `.${window.location.hostname}`
                },
                {
                    // Regex matching cookie name.
                    name: /^_ga/,
                    domain: `.${window.location.hostname}`
                }
            ],
            language: {
                locale: {
                    en: {
                        name: 'Google Analytics'
                    }
                }
            }
        }
    }
});
